/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import gql from "graphql-tag";

export const GET_APPLICATION_BY_ID_FOR_USER = gql`
  query GetApplicationbyIdForUser($applicationId: String) {
    getApplicationbyIdForUser(applicationId: $applicationId) {
      applicationId
      applicant {
        email
      }
      applicationFor
      paymentReceipt {
        paymentReceiptId
      }
      province
      appliedOn
      assessment {
        comments
      }
      applicationType {
        processId
        isCitizen
        isAdult
        processType
        fee
        processTime
      }
      givenName
      familyName
      otherNames
      dateOfBirth
      placeOfBirth
      island
      nationality
      fatherName
      motherName
      maritalStatus
      employmentStatus
      address {
        addressLine1
        addressLine2
        city
        state
        country
      }
      telephone
      passport {
        passportNo
        dateIssued
        expiredDate
        placeIssued
        passportCopyURL
      }
      birthCertificateCopyURL
      nonCitizenPOD {
        countryOfOrigin
        dateEntered
        portOfLastDisembark
        statusInVanuatu
        durBeginInVanuatuFrm
        durBeginInVanuatuTo
        occupation
        businessAddress {
          addressLine1
          addressLine2
          city
          state
          zipcode
          country
        }
        workPermitCopyURL
        confirmationLetterURL
        residentialPermitCopyURL
      }
      applicationCurrentStatus
      applicationStatus {
        applicationStatusId
        state
        message
        uploadedReceiptURL
        updatedOn
      }
      certificate {
        status
      }
      uploadedReceiptURL
      issuedOn
    }
  }
`;
